(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restaurierungen"] && !Shopify.designMode) return;
  try {
    (function(){
function initCF(cf){var track=cf.querySelector(".six-cf__track");var slides=[].slice.call(cf.querySelectorAll(".six-cf__slide"));var dotsWrap=cf.querySelector(".six-cf__dots");if(!slides.length)return;var idx=0;
slides.forEach(function(s,i){var d=document.createElement("button");d.className="six-cf__dot";d.type="button";d.addEventListener("click",function(){go(i);});dotsWrap.appendChild(d);});
function go(i){idx=Math.max(0,Math.min(i,slides.length-1));var vp=cf.querySelector(".six-cf__viewport");var sw=slides[0].getBoundingClientRect().width;var g=parseFloat(getComputedStyle(track).gap)||18;var step=sw+g;var center=(vp.clientWidth-sw)/2;track.style.transform="translateX("+(center-idx*step)+"px)";slides.forEach(function(s,j){s.classList.toggle("is-active",j===idx);});[].slice.call(dotsWrap.children).forEach(function(d,j){d.classList.toggle("is-active",j===idx);});}
cf.querySelector(".six-cf__prev").addEventListener("click",function(){go(idx-1);});cf.querySelector(".six-cf__next").addEventListener("click",function(){go(idx+1);});window.addEventListener("resize",function(){go(idx);});go(0);}
function initBA(ba){var af=ba.querySelector(".six-ba__after");var ai=ba.querySelector(".six-ba__afterimg");var dv=ba.querySelector(".six-ba__divider");var drag=false;function size(){ai.style.width=ba.clientWidth+"px";}function set(p){p=Math.max(0,Math.min(100,p));af.style.width=p+"%";dv.style.left=p+"%";}function fe(e){var x=e.touches?e.touches[0].clientX:e.clientX;var r=ba.getBoundingClientRect();set((x-r.left)/r.width*100);}ba.addEventListener("pointerdown",function(e){drag=true;fe(e);});window.addEventListener("pointermove",function(e){if(drag)fe(e);});window.addEventListener("pointerup",function(){drag=false;});window.addEventListener("resize",size);size();set(50);}
function run(){document.querySelectorAll(".six-cf").forEach(function(c){if(!c.dataset.i){c.dataset.i=1;initCF(c);}});document.querySelectorAll(".six-ba").forEach(function(b){if(!b.dataset.i){b.dataset.i=1;initBA(b);}});}
if(document.readyState!="loading")run();else document.addEventListener("DOMContentLoaded",run);
})();
  } catch(e) { console.error(e); }
})();
})();
